import React from "react";
import PropTypes from "prop-types";

const inputStyle = {
    padding: "10px 14px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    outline: "none",
    fontSize: "14px",
    background: "#fff",
    minWidth: "180px",
};

const buttonStyle = {
    padding: "10px 18px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    background: "#fff",
    cursor: "pointer",
    fontWeight: 600,
    color: "#374151",
};

const ManagementToolbar = ({
    values = {},
    searchPlaceholder = "Search...",
    filters = [],
    onChange,
    onReset,
    resultCount,
    resultLabel = "results",
    showCount = false,
    rightContent = null,
}) => {

    // UPDATE SINGLE FILTER
    const updateValue = (key, value) => {
        if (!onChange) { return; }

        onChange({ ...values, [key]: value });
    };

    // RESET
    const handleReset = () => {
        if (onReset) {
            onReset();
            return;
        }

        if (onChange) {
            const resetValues = { search: "" };
            filters.forEach((filter) => { resetValues[filter.key] = ""; });
            onChange(resetValues);
        }
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "15px",
                flexWrap: "wrap",
                marginBottom: "24px",
                width: "100%",
            }}
        >
            {/* LEFT SIDE */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                    flex: 1,
                }}
            >
                {/* SEARCH */}
                <input
                    type        = "text"
                    placeholder = { searchPlaceholder }
                    value       = { values.search || "" }
                    onChange    = { (event) => updateValue("search", event.target.value) }
                    style       = {{
                        ...inputStyle,
                        flex: "1 1 260px",
                        minWidth: "260px",
                    }}
                />

                {/* DYNAMIC FILTERS */}
                {filters.map((filter) => {
                    const options =
                        Array.isArray(filter.options)
                            ? filter.options
                            : [];

                    return (
                        <select
                            key={filter.key}
                            value={ values[filter.key] || "" }
                            onChange={(event) =>
                                updateValue(
                                    filter.key,
                                    event.target.value
                                )
                            }
                            style={{
                                ...inputStyle,
                                minWidth: filter.minWidth || "180px",
                            }}
                        >
                            {/* DEFAULT / EMPTY OPTION */}
                            <option value="">
                                {filter.placeholder || filter.label}
                            </option>

                            {/* OPTIONS */}
                            {options.map(
                                (option, index) => {

                                    const isObject =
                                        option !== null &&
                                        typeof option === "object";

                                    const value = isObject ? option.value : option;
                                    const label = isObject ? option.label : option;

                                    return (
                                        <option
                                            key={ value ?? `${filter.key}-${index}` }
                                            value={ value ?? "" }
                                        >
                                            {label}
                                        </option>
                                    );
                                }
                            )}
                        </select>
                    );
                })}

                {/* RESULT COUNT */}
                {showCount &&
                    typeof resultCount === "number" && (
                        <span
                            style={{
                                fontSize: "13px",
                                color: "#64748b",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {resultCount}{" "}
                            {resultCount === 1
                                ? resultLabel.replace(/s$/, "")
                                : resultLabel}
                        </span>
                    )
                }

                {/* RESET */}
                <button
                    type="button"
                    style={buttonStyle}
                    onClick={handleReset}
                >
                    Reset
                </button>
            </div>

            {/* RIGHT CONTENT */}
            {rightContent && (
                <div>
                    {rightContent}
                </div>
            )}
        </div>
    );
};

ManagementToolbar.propTypes = {
    values: PropTypes.object,
    searchPlaceholder: PropTypes.string,

    filters: PropTypes.arrayOf(
        PropTypes.shape({
            key:         PropTypes.string.isRequired,
            label:       PropTypes.string.isRequired,
            placeholder: PropTypes.string,
            minWidth:    PropTypes.string,
            options:     PropTypes.array.isRequired,
        })
    ),

    onChange:     PropTypes.func,
    onReset:      PropTypes.func,
    resultCount:  PropTypes.number,
    resultLabel:  PropTypes.string,
    showCount:    PropTypes.bool,
    rightContent: PropTypes.node,
};

export default ManagementToolbar;
